let config = {
  isDebugEnabled: false,
  isDev: false
};
const setupLogger = (userConfig) => {
  config = {
    ...config,
    ...userConfig
  };
};
const logger = {
  log: console.log,
  warn: console.warn,
  error: console.error,
  info: console.info,
  debug: console.debug,
  debugAndCapture: console.debug,
  logDevOnly: (...params) => {
    if (!config.isDev) return;
    console.log(...params);
  }
};
const createPrefixedLogger = (prefix, key, logger2, disabled = false) => (...params) => {
  config.on?.(prefix, key, params, disabled);
  if (disabled) return;
  const newParams = [`[${prefix}](${(/* @__PURE__ */ new Date()).toISOString()})`, ...params];
  logger2(...newParams);
};
const createLogger = (prefix, enabled = Boolean(config.isDev)) => {
  return Object.entries(logger).reduce((res, val) => {
    const [key, logFunction] = val;
    return {
      ...res,
      // error always enabled, other log types only enabled in dev (or if explicitly enabled)
      [key]: createPrefixedLogger(prefix, key, logFunction, !enabled && key !== "error")
    };
  }, {});
};

export { createLogger, setupLogger };
//# sourceMappingURL=index.js.map
